/* Aaria London: product card enhancements.
   Pure progressive enhancement. Reads data Prestige already puts in the DOM,
   overrides nothing, and does not touch any Prestige file.

   1. Clicking a card swatch swaps the card image. Prestige only does this on
      hover, so it never works on a phone.
   2. Clicking a card swatch shows the option name, e.g. "14K Gold Vermeil".
   3. On touch devices, tap the left or right half of a card image to flip
      between the primary and secondary shot, with dots to show where you are.
      Prestige hides the second image entirely on coarse pointers.
*/
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function parseMedia(el, attr) {
    var raw = el.getAttribute(attr);
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }

  function srcAt(media, width) {
    var img = media && media.preview_image ? media.preview_image : media;
    if (!img || !img.src) return null;
    var sep = img.src.indexOf('?') === -1 ? '?' : '&';
    return img.src + sep + 'width=' + width;
  }

  function buildSrcset(media) {
    var widths = [200, 300, 400, 500, 600, 800, 1000];
    var img = media && media.preview_image ? media.preview_image : media;
    if (!img || !img.src) return '';
    var max = img.width || 1000;
    return widths.filter(function (w) { return w <= max; })
      .map(function (w) { return srcAt(media, w) + ' ' + w + 'w'; })
      .join(', ');
  }

  function applyMedia(imgEl, media) {
    if (!imgEl || !media) return;
    var s = srcAt(media, 600);
    if (!s) return;
    imgEl.src = s;
    var ss = buildSrcset(media);
    if (ss) imgEl.srcset = ss;
    var img = media.preview_image || media;
    if (img.alt) imgEl.alt = img.alt;
  }

  /* --- 1 and 2: swatch click swaps image and shows the name ------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    if (!input.closest('.product-card__info')) return;

    var card = input.closest('.product-card') || input.closest('product-card');
    if (!card) return;

    var primary = card.querySelector('.product-card__image--primary');
    var secondary = card.querySelector('.product-card__image--secondary');

    applyMedia(primary, parseMedia(input, 'data-variant-media'));
    applyMedia(secondary, parseMedia(input, 'data-variant-secondary-media'));

    // Name of the chosen option, taken from the label's screen reader text.
    var label = card.querySelector('label[for="' + input.id + '"]');
    var name = label ? (label.textContent || '').trim() : (input.value || '').trim();
    if (!name) return;

    var info = card.querySelector('.product-card__info');
    if (!info) return;
    var out = info.querySelector('.aaria-card__option');
    if (!out) {
      out = document.createElement('span');
      out.className = 'aaria-card__option';
      var anchor = info.querySelector('fieldset');
      if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(out, anchor);
      else info.appendChild(out);
    }
    out.textContent = name;
  });

  /* --- 3: tap to flip between the two images on touch devices ----- */
  var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  if (!coarse) return;

  function enhance(card) {
    if (card.dataset.aariaFlip) return;
    var media = card.querySelector('.product-card__media');
    var primary = card.querySelector('.product-card__image--primary');
    var secondary = card.querySelector('.product-card__image--secondary');
    if (!media || !primary || !secondary) return;
    card.dataset.aariaFlip = '1';

    media.classList.add('aaria-flip');

    var dots = document.createElement('span');
    dots.className = 'aaria-flip__dots';
    dots.innerHTML = '<i class="is-on"></i><i></i>';
    media.appendChild(dots);

    var nav = document.createElement('span');
    nav.className = 'aaria-flip__nav';
    nav.innerHTML = '<button type="button" aria-label="Previous image"></button><button type="button" aria-label="Next image"></button>';
    media.appendChild(nav);

    var index = 0;
    function show(i) {
      index = i < 0 ? 1 : (i > 1 ? 0 : i);
      media.classList.toggle('is-second', index === 1);
      var lit = dots.querySelectorAll('i');
      for (var k = 0; k < lit.length; k++) lit[k].classList.toggle('is-on', k === index);
    }

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var which = Array.prototype.indexOf.call(nav.children, btn);
      show(which === 0 ? index - 1 : index + 1);
    });

    /* Swipe across the photo to change it.

       The stylesheet puts touch-action: pan-y on the image, so the
       browser hands sideways drags here instead of scrolling the rail
       these cards sit in. Without that the row would move and the photo
       would not.

       The threshold is deliberately higher than the one used to decide
       the direction, so a lazy diagonal scroll down the page does not
       register as a swipe sideways. */
    var startX = null;
    var startY = null;
    var swiped = false;

    media.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      swiped = false;
    }, { passive: true });

    /* Acted on during the drag rather than waiting for the finger to
       come up, and at a shorter distance. Waiting for touchend is what
       made it feel like it was sticking: a slow or short swipe did
       nothing at all until the finger lifted, and often nothing then
       either, so the photo appeared to ignore the gesture. Twenty four
       pixels is far enough not to fire on a tap and near enough to
       answer straight away. */
    media.addEventListener('touchmove', function (e) {
      if (startX === null || swiped || e.touches.length !== 1) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;

      if (Math.abs(dx) > 24 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        show(dx < 0 ? index + 1 : index - 1);
      }
    }, { passive: true });

    media.addEventListener('touchend', function () {
      startX = startY = null;
    }, { passive: true });

    /* A swipe ends in a click as far as the browser is concerned, and
       the photo sits inside the link to the product. Caught on the way
       down so the swipe does not also open the product page. */
    media.addEventListener('click', function (e) {
      if (!swiped) return;
      swiped = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function scan(scope) {
    var cards = (scope || document).querySelectorAll('.product-card');
    for (var i = 0; i < cards.length; i++) enhance(cards[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Collection filtering and pagination replace the grid, so watch for it.
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) scan(added[j]);
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ===================================================================
   Rating badge scrolls to the Loox reviews.

   Prestige renders the rating as a plain span with no href and no
   handler, so clicking the stars did nothing. Loox supplies the
   review list in its own app block further down the page. This joins
   the two.

   Separate IIFE on purpose: the block above returns early on fine
   pointers, so anything appended inside it would never run on
   desktop.

   Loox loads async, so the target may not exist yet. Retries for a
   few seconds, then gives up quietly. If Loox is absent the badge is
   left exactly as Prestige rendered it.
   =================================================================== */
(function () {
  function reviewsTarget() {
    return document.querySelector('#looxReviews')
        || document.querySelector('[id*="loox_dynamic_section"]')
        || document.querySelector('[id*="loox_reviews"]');
  }

  function wire() {
    var badge = document.querySelector('.product-info .rating-badge');
    if (!badge || badge.getAttribute('data-aaria-reviews')) return false;

    var dest = reviewsTarget();
    if (!dest) return false;

    badge.setAttribute('data-aaria-reviews', '1');
    badge.setAttribute('role', 'button');
    badge.setAttribute('tabindex', '0');

    function go() {
      var section = dest.closest('section') || dest;
      var sticky = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height'), 10
      ) || 0;
      var top = section.getBoundingClientRect().top + window.pageYOffset - sticky - 16;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    badge.addEventListener('click', go);
    badge.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        go();
      }
    });
    return true;
  }

  var tries = 0;
  function attempt() {
    if (wire() || ++tries > 20) return;
    setTimeout(attempt, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attempt);
  } else {
    attempt();
  }
})();

/* ===================================================================
   Desktop gallery hero: correct the sizes attribute.

   Prestige builds the gallery's sizes attribute for grid_2x by
   halving the gallery width, which is right for its own 50/50 grid.
   The Aaria desktop layout is 68/32, so the hero renders at about
   465px while sizes still claims 294px, and the browser serves a file
   too small for the slot. On a cut out jewellery shot that reads as
   soft.

   Only corrects when the image is actually being upscaled past 1.2x,
   and only on the wide layout, so mobile is untouched. Mobile already
   gets a correct 100vw sizes value, and mobile is 90% of traffic, so
   nothing here costs the majority anything.
   =================================================================== */
(function () {
  if (!window.matchMedia || !window.matchMedia('(min-width: 1000px)').matches) return;

  function correct() {
    var img = document.querySelector('.product-gallery__media img');
    if (!img || img.getAttribute('data-aaria-sized')) return;
    if (!img.naturalWidth) return;

    var width = img.getBoundingClientRect().width;
    if (!width) return;

    if (width / img.naturalWidth > 1.2) {
      img.setAttribute('data-aaria-sized', '1');
      img.setAttribute('sizes', Math.ceil(width) + 'px');
    }
  }

  function start() {
    var img = document.querySelector('.product-gallery__media img');
    if (!img) return;
    if (img.complete) correct();
    else img.addEventListener('load', correct, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ===================================================================
   Sticky add to cart on mobile.

   Prestige's own product-sticky-bar never fires: its observer does not
   toggle is-visible, and forcing that class by hand still leaves the
   element computing to visibility: hidden. This drives the same
   element with our own class instead, using a plain scroll listener
   rather than an IntersectionObserver so there is nothing to fail
   silently.

   Shows once the buy form has scrolled above the viewport and hides
   again once the footer comes into view, which is the behaviour
   Prestige intended.

   Runs at every width. On desktop the sticky buy column keeps the
   button on screen until the product section ends, so the bar simply
   appears later down the page.
   =================================================================== */

/* ===================================================================
   Solid Gold cards: karat split and stock badge.

   Only runs where the Solid Gold hero has published card data, so it
   is inert on every other collection.

   Prestige's product card carries no variant data: its swatches are
   built from option values, not variants, so nothing in the grid
   knows what a 14k costs or whether it is in stock. The data comes
   from #aaria-sg-card-data, rendered once for the whole page by
   snippets/aaria-card-data.liquid, rather than a fetch per card.

   Two things get written into each card:

   1. The karat split, replacing Prestige's bare "From £490.00". The
      step from 9k to 14k is the margin decision on this range, and
      behind a click it is a decision nobody makes.

   2. A stock badge, In stock or Made to order, driven by whether the
      selected option value has any available variant. Where a card has
      swatches it follows the swatch, because a card showing In stock
      while a 14k swatch is selected and unavailable is worse than no
      badge at all.

   Prices are already formatted by Liquid, so the store's money format
   and the customer's market currency are respected without any of
   that logic living here.
   =================================================================== */
(() => {
  const dataEl = document.getElementById('aaria-sg-card-data');
  if (!dataEl) return;

  let data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch {
    return; // Malformed data leaves the cards exactly as Prestige rendered them.
  }
  if (!data || typeof data !== 'object') return;

  const IN_STOCK = 'In stock';
  const MADE_TO_ORDER = 'Made to order';

  /* The handle, read off the product link. The only id in a card is the
     quick buy input and that holds a variant id, so there is nothing
     else in the markup that identifies the product itself. */
  const idFor = (card) => {
    const known = card.getAttribute('data-aaria-handle');
    if (known) return known;
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    const match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!match) return null;
    const handle = decodeURIComponent(match[1]);
    card.setAttribute('data-aaria-handle', handle);
    return handle;
  };

  const badgeFor = (card) => {
    let el = card.querySelector('.aaria-card-stock');
    if (!el) {
      el = document.createElement('span');
      el.className = 'aaria-card-stock';
      const anchor = card.querySelector('.product-card__info') || card;
      anchor.appendChild(el);
    }
    return el;
  };

  const setBadge = (card, available) => {
    const el = badgeFor(card);
    el.textContent = available ? IN_STOCK : MADE_TO_ORDER;
    el.classList.toggle('aaria-card-stock--in', !!available);
    el.classList.toggle('aaria-card-stock--made', !available);
  };

  /* A swatch input's value is the option value, which is the key the
     data is written under. Checked state is what the customer sees. */
  const selectedValue = (card) => {
    const checked = card.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    return checked && checked.value ? String(checked.value).toLowerCase().trim() : null;
  };

  const applyStock = (card, entry) => {
    const value = selectedValue(card);
    if (value && Object.prototype.hasOwnProperty.call(entry.o || {}, value)) {
      setBadge(card, entry.o[value]);
    } else {
      setBadge(card, entry.a);
    }
  };

  const applyKarat = (card, entry) => {
    if (!entry.k || entry.k.length === 0) return;
    if (card.querySelector('.aaria-card-karat')) return;

    /* Prestige renders the price as <price-list>, not .price. */
    const price = card.querySelector('price-list');
    if (!price) return;

    const line = document.createElement('span');
    line.className = 'aaria-card-karat';
    entry.k.forEach((k, i) => {
      if (i > 0) {
        const sep = document.createElement('span');
        sep.className = 'aaria-card-karat__sep';
        sep.textContent = '·';
        line.appendChild(sep);
      }
      line.appendChild(document.createTextNode(`${k.l} from ${k.p}`));
    });

    /* Replaces the bare From price rather than sitting beside it, so
       the card does not state the same number twice. */
    price.setAttribute('hidden', '');
    price.insertAdjacentElement('afterend', line);
  };

  const enhance = (card) => {
    const id = idFor(card);
    if (!id) return;
    const entry = data[id];
    if (!entry) return;
    applyKarat(card, entry);
    applyStock(card, entry);
  };

  const enhanceAll = () => {
    document.querySelectorAll('.product-card, product-card').forEach(enhance);
  };

  enhanceAll();

  /* Swatch clicks change the selected variant without a page load, and
     the grid is replaced wholesale when a filter or a sort is applied,
     so both need picking up again. */
  document.addEventListener('change', (event) => {
    const card = event.target.closest && event.target.closest('.product-card, product-card');
    if (!card) return;
    const id = idFor(card);
    if (id && data[id]) applyStock(card, data[id]);
  });

  /* childList only, and never subtree. Writing a badge into a card is itself
     a mutation inside the grid, so a subtree observer re-triggers on its own
     output and spins forever: it froze the renderer outright the first time.
     Cards are direct children, so watching the list itself sees a filter or a
     sort replace them, which is the only case that needs re-running.

     The guard covers the other half of it. enhanceAll appends elements, which
     queues another callback even at this depth, so re-entering while a pass is
     already in flight has to be impossible rather than merely unlikely. */
  const grid = document.querySelector('.product-list');
  if (grid && 'MutationObserver' in window) {
    let running = false;
    const observer = new MutationObserver(() => {
      if (running) return;
      running = true;
      enhanceAll();
      requestAnimationFrame(() => { running = false; });
    });
    observer.observe(grid, { childList: true });
  }
})();
